<template>
    <LoadingComponent :props="loading" />
    <div class="db-card">
        <div class="db-card-header items-center justify-between gap-4">
            <h3 class="db-card-title">{{ $t('menu.product_categories') }}</h3>
        
            <div class="flex items-center gap-2">
                <button
                    type="button"
                    class="db-btn h-9 py-2 px-3 text-white bg-primary ml-3"
                    @click="refreshFromServer"
                    :disabled="isRefreshingView"
                    :class="{ 'disabled:opacity-50 disabled:bg-gray': isRefreshingView }"
                >
                    <template v-if="isRefreshingView">
                        <svg class="inline-block animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                            <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                        </svg>
                    </template>
                    <template v-else>
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </template>
                </button>
            </div></div>
        <div class="db-card-body">
            <div class="row">
                <div class="col-12 sm:col-5">
                    <img class="db-image" alt="category" :src="productCategory.cover">
                </div>
                <div class="col-12 sm:col-7 md:pl-8">
                    <h3 class="text-lg font-medium capitalize mb-2 text-paragraph">{{ productCategory.name }}</h3>
                    <label class="db-badge mb-3" :class="statusClass(productCategory.status)">
                        {{ enums.statusEnumArray[productCategory.status] }}
                    </label>
                    <p class="db-light-text">
                        {{ productCategory.description }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingComponent from "../../components/LoadingComponent";
import statusEnum from "../../../../enums/modules/statusEnum";
import appService from "../../../../services/appService";
import alertService from "../../../../services/alertService";

export default {
    name: "ProductCategoryShowComponent",
    components: {
        LoadingComponent
    },
    data() {
        return {
            isRefreshingView: false,
            loading: {
                isActive: false
            },
            enums: {
                statusEnum: statusEnum,
                statusEnumArray: {
                    [statusEnum.ACTIVE]: this.$t("label.active"),
                    [statusEnum.INACTIVE]: this.$t("label.inactive")
                }
            }
        }
    },
    computed: {
        productCategory: function () {
            return this.$store.getters['productCategory/show'];
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData: function (showOverlay = true) {
            if (showOverlay) {
                this.loading.isActive = true;
            }
            return this.$store.dispatch('productCategory/show', this.$route.params.id).then(res => {
                if (showOverlay) {
                    this.loading.isActive = false;
                }
            }).catch((err) => {
                if (showOverlay) {
                    this.loading.isActive = false;
                }
            });
        },
        refreshFromServer: function () {
            if (this.isRefreshingView) {
                return;
            }
            this.isRefreshingView = true;
            this.fetchData(false).then(() => {
                alertService.info(this.$t('button.refresh'));
                this.isRefreshingView = false;
            }).catch(() => {
                this.isRefreshingView = false;
            });
        },
        statusClass: function (status) {
            return appService.statusClass(status);
        }
    }
}
</script>